import AddBlue from '@components/icons/AddBlue.svg';
import { TAddPlusButtonVariant, TProps } from './types/TProps';

const variantIconSize: Record<TAddPlusButtonVariant, string> = {
  default: '[&_svg]:h-6 [&_svg]:w-6',
  workspace: '[&_svg]:h-[26px] [&_svg]:w-[26px]',
  avatar: '[&_svg]:h-6 [&_svg]:w-6',
};

export const AddPlusButton = ({
  onClick,
  variant = 'default',
  liClassName = 'flex',
  ariaLabel = 'Add item',
  disabled,
}: TProps) => {
  const iconSizeClass = variantIconSize[variant];

  return (
    <li className={liClassName}>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel}
        className={`flex h-[72px] w-[72px] cursor-pointer items-center justify-center rounded-[5px] border border-dashed border-[var(--color-banner-button-text)] bg-transparent p-0 text-[var(--color-banner-button-text)] enabled:hover:border-[var(--color-link)] enabled:hover:bg-transparent enabled:hover:text-[var(--color-link)] disabled:pointer-events-none disabled:cursor-not-allowed disabled:border-[var(--color-button-disabled-text)] disabled:bg-[var(--color-button-disabled-bg)] disabled:text-[var(--color-button-disabled-text)] ${iconSizeClass} [&_svg]:block [&_svg]:shrink-0`}
      >
        <AddBlue />
      </button>
    </li>
  );
};
